import type { Product } from '@frontend/libs/types/product'
import type React from 'react'
import type { SwiperOptions } from 'swiper/types'

import { type Image, ImageSize } from '@frontend/libs/types/media'
import ProductItem from '@scripts/frontend/features/products/components/product-item/ProductItem'
import { ProductImage } from '@scripts/frontend/features/products/components/ProductImage'
import { __ } from '@wordpress/i18n'
import 'swiper/css'
import 'swiper/css/navigation'
import { Navigation } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/react'

export interface CompleteTheLookProps {
  gallery: Image[]
  products: Product[]
}

const swiperOptions: SwiperOptions = {
  modules: [Navigation],
  navigation: true,
  slidesPerView: 1,
}

export function CompleteTheLook({
  gallery,
  products,
}: Readonly<CompleteTheLookProps>): React.JSX.Element {
  return (
    <section className="complete-the-look my-16 grid grid-cols-1">
      <h1 className="mb-4 text-xl font-medium uppercase md:text-2xl">
        {__('Complete the look', 'asavagroup')}
      </h1>
      <div className="relative grid grid-cols-1 gap-14 md:grid-cols-12">
        <div className="md:col-span-3">
          <div className="grid grid-cols-1 gap-4">
            {products.map((product) => (
              <ProductItem key={product.id} product={product} />
            ))}
          </div>
        </div>
        <div className="md:col-span-9">
          <div className="mx-auto max-w-screen-md">
            <div className="sticky top-0">
              <div className="overflow-hidden">
                <Swiper {...swiperOptions}>
                  {gallery?.map((image) => (
                    <SwiperSlide key={image.id}>
                      <ProductImage
                        className="select-none object-cover"
                        image={image}
                        size={ImageSize.Medium}
                      />
                    </SwiperSlide>
                  ))}
                </Swiper>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default CompleteTheLook
